import { GUTTER_MD, MODAL_WIDTH_LG} from '../../../../../styles/constants';
import React from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {translate} from 'react-i18next';
import {getLoaderCsvFormRowListCsvRows, hideLoaderCsvFormRowList} from './actions';
import EnhancedModal from '../../../../../components/enhanced-modal';
import {Button, Col, Row, Select} from "antd";
import {getFilterObjFromViewerObj} from "../../../../../utils/filter";
import InfiniteScrollDataTable from "../../../../../components/infinite-scroll-data-table";
import { setLoaderCsvFormMappingControlSequenceMappingIndex } from '../mapping-control/actions';

const mapStateToProps = state => ({
  isVisible: state.scenes.dataManager.loader.components.csvForm.components.rowList.isVisible,
  tid: state.scenes.dataManager.loader.components.csvForm.shared.tid,
  mappingId: state.scenes.dataManager.loader.components.csvForm.shared.mappingId,
  separator: state.scenes.dataManager.loader.components.csvForm.shared.separator,
  delimiter: state.scenes.dataManager.loader.components.csvForm.shared.delimiter,
  hasHeader: state.scenes.dataManager.loader.components.csvForm.shared.hasHeader,
  hasDotStatFormat: state.scenes.dataManager.loader.components.csvForm.shared.hasDotStatFormat,
  csvServerPath: state.scenes.dataManager.loader.components.csvForm.shared.csvServerPath,
  format: state.scenes.dataManager.loader.shared.format,
  csvRows: state.scenes.dataManager.loader.components.csvForm.components.rowList.csvRows,
  selectedMappingIsSequence: state.scenes.dataManager.loader.components.csvForm.shared.selectedMappingIsSequence,
  seqMappings: state.scenes.dataManager.loader.components.csvForm.shared.seqMappings,
  seqMappingsIndex: state.scenes.dataManager.loader.components.csvForm.shared.seqMappingsIndex,
  mappingCube: state.scenes.dataManager.loader.components.csvForm.shared.mappingCube,
});

const mapDispatchToProps = dispatch => ({
  onHide: () => dispatch(hideLoaderCsvFormRowList()),
  fetchCsvRows: (pageNum, pageSize, filterTable, sortCols, sortByDesc, separator, delimiter, hasHeader, tid, filePath, idMappingSpecialTimePeriod, mode) =>
    dispatch(getLoaderCsvFormRowListCsvRows(pageNum, pageSize, filterTable, sortCols, sortByDesc, separator, delimiter, hasHeader, tid, filePath, idMappingSpecialTimePeriod, mode)),
  onSeqMappingsIndexSet : (index) => dispatch(setLoaderCsvFormMappingControlSequenceMappingIndex(index))
});

const LoaderCsvFormRowList = ({
                                t,
                                isVisible,
                                tid,
                                mappingId,
                                separator,
                                delimiter,
                                hasHeader,
                                hasDotStatFormat,
                                csvServerPath,
                                csvRows,
                                onHide,
                                fetchCsvRows,
                                format,
                                selectedMappingIsSequence,
                                seqMappings,
                                seqMappingsIndex,
                                onSeqMappingsIndexSet,
                                mappingCube
                              }) => {
  const handleOnTableChange = (pageNum, pageSize, searchText, filters, sortCol, sortByDesc) => {
    
    const currentSeqMapping = selectedMappingIsSequence && seqMappingsIndex >= 0 && (seqMappings || []).length > 0
      ? seqMappings[seqMappingsIndex]
      : null;

    const filterTable = getFilterObjFromViewerObj(
      csvRows &&
      csvRows.Columns.filter(colName => colName !== 'NumRow'),
      searchText,
      filters
    );
    const srcSeparator = format === 'px' ? ';' : (currentSeqMapping ? currentSeqMapping.CSVSeparator : separator);
    const srcDelimiter = currentSeqMapping ? currentSeqMapping.CSVDelimiter : delimiter;
    const fetchDelimiter = format === 'px' ? '"' : (!!srcDelimiter ? srcDelimiter : null);
    const srcHasHeader = format === 'px' ? true : (currentSeqMapping ? currentSeqMapping.HasHeader : hasHeader);
    const srcTid = !tid ? null : tid;
    const idMappingSpecialTimePeriod = currentSeqMapping 
      ? currentSeqMapping.HasSpecialTimePeriod ? currentSeqMapping.IDMapping : null
      : hasDotStatFormat ? mappingId : null;

    fetchCsvRows(
      pageNum,
      pageSize,
      filterTable,
      sortCol ? [sortCol] : null,
      sortByDesc,
      srcSeparator,
      fetchDelimiter,
      srcHasHeader,
      srcTid,
      csvServerPath,
      idMappingSpecialTimePeriod,
      format === 'plugin' ? 2 : null
    );
  }

  const onCloseModal = () => {
    if (selectedMappingIsSequence) {
      onSeqMappingsIndexSet(0);
    }    
    onHide();
  }

  const handleSelectChange = (index) => {
    onSeqMappingsIndexSet(index)
  }

  return (
    <EnhancedModal
      visible={isVisible}
      onCancel={onCloseModal}
      title={t('scenes.dataManager.loader.csvForm.rowList.title')}
      width={MODAL_WIDTH_LG}
      footer={<Button onClick={onCloseModal}>{t('commons.buttons.close.title')}</Button>}
    >    
      {csvServerPath !== null && (
        <InfiniteScrollDataTable
          key={csvServerPath}
          data={csvRows && csvRows.Data}
          rowTotal={csvRows && csvRows.Count}
          cols={csvRows && csvRows.Columns}
          hiddenCols={['NumRow']}
          onChange={ 
            ({pageNum, pageSize, searchText, filters, sortCol, sortByDesc}) => 
              handleOnTableChange(pageNum, pageSize, searchText, filters, sortCol, sortByDesc)
          }
          rightActions={
            selectedMappingIsSequence
            ? (
              <Row type="flex" justify="end" gutter={GUTTER_MD}>
                <Col>
                  <Select 
                    value={seqMappingsIndex} 
                    onSelect={(index) => handleSelectChange(index)} 
                  >
                    {(seqMappings || []).map((mapping, index) =>
                      <Select.Option 
                        key={index} 
                        value={index}
                      >                    
                        {mapping.Name}
                      </Select.Option>
                    )}
                  </Select>
                </Col>
              </Row>
            )
            : null
          }
        />
      )}
    </EnhancedModal>
  );
}

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps)
)(LoaderCsvFormRowList);
